/* eslint-disable @next/next/no-img-element */

import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

/**
 * @component
 */
const ImageCard = ({
  image,
  slug,
  timestamp,
  heading,
  isMainColumn,
}: {
  slug: string;
  heading: string;
  timestamp: string;
  image: {
    data: BlogApi.Image;
  };
  isMainColumn: boolean;
}) => {
  return (
    <Link href={`/blog/${slug}`}>
      <a
        className={classNames(
          'h-full',
          isMainColumn && 'm-auto w-full tablet:col-span-2 desktop:col-span-1',
        )}
      >
        <article className="h-full">
          <Image
            layout="responsive"
            height={254 * 3}
            width={380 * 3}
            alt={image.data?.attributes?.alternativeText || 'Blog Post Image'}
            src={image.data?.attributes?.url ? image.data?.attributes?.url : '/DefaultArticle.png'}
            className="rounded-lg object-cover"
          />

          <div className="py-4">
            <p className="text-gray-4 text-subtitle-2">{timestamp}</p>
            <p className="font-medium text-body-1">{heading}</p>
          </div>
        </article>
      </a>
    </Link>
  );
};

export default ImageCard;
